module.exports = __webpack_public_path__ + "static/annsandi-0e8a0b0f8679612349abd5faeca96233.jpeg";